/*
  MIKOO: saved products ("מוצרים שאהבתי"), on every page.
  The list is product handles in localStorage 'mk_saved', newest first, kept in this browser only (no login).
  Every [data-mk-heart] button shows aria-pressed; the header heart (.mk-saved-link) appears with a count once
  something is saved. On /pages/wishlist (section mikoo-saved) the cards are fetched as the site's own product
  cards through the alternate template product.mk-card.liquid.
  Motion: a short pop on the heart and on the header heart when saving (it shows where the product went);
  on the saved page a removed card fades and the others glide into its place. Nothing moves with reduced motion.
*/
(function () {
  var KEY = 'mk_saved';
  var MAX = 120;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-mk-heart]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-mk-heart')) > -1;
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
    });
    document.querySelectorAll('[data-mk-saved-link]').forEach(function (link) {
      link.classList.toggle('mk-saved-link--empty', list.length === 0);
      var count = link.querySelector('[data-mk-saved-count]');
      if (count) count.textContent = list.length < 100 ? String(list.length) : '';
    });
  }

  function pop(el) {
    if (!el || reduce.matches || !el.animate) return;
    el.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }],
      { duration: 340, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
    );
  }

  var live;
  function announce(text) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-mk-heart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-mk-heart');
    var list = read();
    var index = list.indexOf(handle);
    var on = index === -1;
    if (on) list.unshift(handle);
    else list.splice(index, 1);
    write(list);
    sync();
    if (on) {
      pop(btn.querySelector('svg'));
      document.querySelectorAll('[data-mk-saved-link] .svg-wrapper').forEach(pop);
      announce('נשמר במוצרים שאהבתי');
      if (window.mkTrack) window.mkTrack('mk_wishlist_add');
    } else {
      announce('הוסר ממוצרים שאהבתי');
    }
    document.dispatchEvent(new CustomEvent('mk:saved-change', { detail: { handle: handle, on: on } }));
  });

  // Dawn redraws cards after a filter, sort or "load more": give the new hearts their state.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('storage', function (event) { if (event.key === KEY) sync(); });
  window.addEventListener('pageshow', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  /* ---------- the saved page ---------- */
  function savedPage(root) {
    var grid = root.querySelector('[data-mk-saved-grid]');
    var empty = root.querySelector('[data-mk-saved-empty]');
    var countEl = root.querySelector('[data-mk-saved-total]');
    var list = read();

    function showCount() {
      var n = grid.children.length;
      if (countEl) countEl.textContent = n === 0 ? '' : n === 1 ? 'מוצר אחד' : n + ' מוצרים';
      root.classList.toggle('mk-saved--empty', n === 0);
      if (empty) empty.hidden = n !== 0;
    }

    if (!list.length) {
      root.classList.remove('mk-saved--loading');
      showCount();
      return;
    }

    var html = new Array(list.length);
    var gone = [];
    var next = 0;
    function load() {
      if (next >= list.length) return Promise.resolve();
      var i = next++;
      return fetch('/products/' + encodeURIComponent(list[i]) + '?view=mk-card', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) { gone.push(list[i]); return ''; }
          return r.ok ? r.text() : '';
        })
        .catch(function () { return ''; })
        .then(function (text) { html[i] = text; return load(); });
    }
    var workers = [];
    for (var w = 0; w < Math.min(6, list.length); w++) workers.push(load());
    Promise.all(workers).then(function () {
      var frag = document.createDocumentFragment();
      list.forEach(function (handle, i) {
        if (!html[i] || html[i].indexOf('card-wrapper') === -1) return;
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.setAttribute('data-mk-saved-item', handle);
        li.innerHTML = html[i];
        frag.appendChild(li);
      });
      grid.appendChild(frag);
      // products that were deleted from the store leave the list
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      root.classList.remove('mk-saved--loading');
      showCount();
      sync();
    });

    document.addEventListener('mk:saved-change', function (event) {
      if (event.detail.on) return;
      var item = grid.querySelector('[data-mk-saved-item="' + CSS.escape(event.detail.handle) + '"]');
      if (!item) return;
      if (reduce.matches || !item.animate) {
        item.remove();
        showCount();
        return;
      }
      item.style.pointerEvents = 'none';
      item.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-out', fill: 'forwards' }).finished.then(function () {
        var others = Array.prototype.filter.call(grid.children, function (el) { return el !== item; });
        var before = others.map(function (el) { return el.getBoundingClientRect(); });
        item.remove();
        others.forEach(function (el, i) {
          var after = el.getBoundingClientRect();
          var dx = before[i].left - after.left;
          var dy = before[i].top - after.top;
          if (dx || dy) {
            el.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 280, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
          }
        });
        showCount();
      });
    });
  }

  function start() {
    var root = document.querySelector('[data-mk-saved]');
    if (root) savedPage(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
